var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":""},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('font-awesome-icon',{attrs:{"icon":"fad fa-spinner","spin":"","size":"5x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }